import { PropsType } from "./Title.props"
import { StyleForTitle, StyleForSubheader } from './Title.presents'

export const Title = (props: PropsType) => {
  return <StyleForTitle {...props}>{props.text}</StyleForTitle>
}
export const Subheader = (props: PropsType) => {
  return <StyleForSubheader {...props}>{props.text}</StyleForSubheader>
}